import amplitude from 'amplitude-js';

const ADMIN_ROLE = 'Admin';

export const trackAmplitude = (eventName, eventData, user = undefined, callback = undefined) => {
  const amplitudeInstance = amplitude.getInstance();
  if (!amplitudeInstance) {
    return;
  }

  const signedInAsAdmin = document.cookie.split('; ').includes('signed_in_through_admin=true');

  if (!signedInAsAdmin && (!user || user.role !== ADMIN_ROLE)) {
    if (user) {
      amplitudeInstance.setUserId(user.id);
    }
    amplitudeInstance.logEvent(eventName, eventData, callback);
  } else {
    /* eslint-disable-next-line no-console */
    console.log(`Amplitude is disabled for admins: "${eventName}", ${JSON.stringify(eventData)}`);
    if (callback) callback();
  }
};
